import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

function ModalComponent(props) {
  return (
  	<React.Fragment>
	  {
	  	props.isOpen ?
	  	<div className="modal">
	  		<div className="modal-overlay">
				  <div className="modal-title ">
					  <div className="fs-16 w-600">{props.title}</div>
					  <FontAwesomeIcon icon="times" className="close" onClick={props.onClose}/>
				  </div>
				  <div className="modal-body">
				  	{props.body}
				  </div>
	  		</div>
	  	</div> : null
	  }
  </React.Fragment>

  );
}

export default ModalComponent;
